module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile_79829a.jpg";